// THE TARGET UNDER DISCUSSION — where, in the student's current words, the writing TWS is talking about sits. Existing data only: the
// DCO's VERBATIM `focus_portion` (the smaller span worked on this turn) or `focus_region` (the whole function in focus), passed through on
// the compose dialogue turn. Deterministic, confidence-gated: the verbatim text must occur EXACTLY ONCE in the editor text (exact match
// first, then a single case-insensitive match). Ambiguous, absent, or too short → null → no highlight. Never a guess.
const MIN_CHARS = 12;

export function locateTarget(text, focus) {
  const hay = text || "";
  const needle = (focus || "").trim();
  if (needle.length < MIN_CHARS || !hay) return null;
  const once = (h, n) => {
    const i = h.indexOf(n);
    return i >= 0 && h.indexOf(n, i + 1) < 0 ? i : -1;
  };
  let i = once(hay, needle);
  if (i < 0) i = once(hay.toLowerCase(), needle.toLowerCase());
  return i < 0 ? null : { start: i, end: i + needle.length };
}

// the current turn's target: the LAST TWS compose turn for this unit that names one (portion preferred — the smaller span worked on now)
export function currentFocusText(dialogue, unitId) {
  const turns = (dialogue || []).filter((d) => d && d.role === "tws" && (!unitId || d.unit_id === unitId) && !d.pending);
  const last = turns[turns.length - 1];
  if (!last) return "";
  return (last.focus_portion || last.focus_region || "").trim();
}
